import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import './../../styles/admin/pedidos.css';
import * as globals from '../../components/GlobalScripts.js';

function safeJsonParse(maybe) {
    try {
        if (!maybe) return null;
        if (typeof maybe === 'string') return JSON.parse(maybe);
        if (typeof maybe === 'object') return maybe;
        return null;
    } catch {
        return null;
    }
}

function getDishNombre(dish) {
    if (!dish) return '';
    return String(dish.nombre || dish.name || dish.titulo || '').trim();
}

function getOrderDishSnapshot(order) {
    const dishInfo = safeJsonParse(order?.dish_info) || {};
    const snapshot = dishInfo?.snapshot || {};
    return {
        entry: snapshot?.entry || null,
        main: snapshot?.main || null,
        snack: snapshot?.snack || null,
        dishInfo,
    };
}

const Admin_pedidos = () => {
    const [orders, setOrders] = useState([]);

    const [searchDate, setSearchDate] = useState('');
    const [searchState, setSearchState] = useState('');
    const [searchType, setSearchType] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [step, setStep] = useState(1);

    const [resumen, setResumen] = useState(null);
    const [resumenLoading, setResumenLoading] = useState(false);

    const navigate = useNavigate();
    const path_api = localStorage.getItem('path_api');
    const itemsPerPage = 10;

    const getOrders = (page = 1, search = '') => {
        globals.openViewCharge();
        axios
            .post(`${path_api}/update-orders/get_orders.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                page,
                itemsPerPage,
                search,
                searchState,
                searchType,
            })
            .then((response) => {
                if (response.data?.mensaje === 'success') {
                    setOrders(Array.isArray(response.data?.orders) ? response.data.orders : []);
                    setTotalPages(Number(response.data?.totalPages || 1));
                } else {
                    globals.createAlert({
                        type: 'error',
                        msg_title: 'Error',
                        msg: response.data?.mensaje || 'No se obtuvieron los pedidos',
                        effect: 'opacidad 2s, desplazamiento 2s',
                        time_life: 4000,
                    });
                }
            })
            .catch(() => {
                globals.createAlert({
                    type: 'error',
                    msg_title: 'Error',
                    msg: 'Error al cargar los pedidos',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            })
            .finally(() => {
                globals.closeViewCharge();
            });
    };

    const getResumen = async () => {
        if (!searchDate || !searchType) {
            setResumen(null);
            return;
        }

        setResumenLoading(true);
        globals.openViewCharge();

        try {
            const res = await axios.post(`${path_api}/update-orders/get_orders.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                page: 1,
                itemsPerPage: 1,
                search: searchDate,
                searchState,
                searchType,
                withSummary: true,
            });

            if (res.data?.mensaje === 'success') {
                setResumen(res.data?.resumen || null);
            } else {
                setResumen(null);
            }
        } catch {
            setResumen(null);
        } finally {
            globals.closeViewCharge();
            setResumenLoading(false);
        }
    };

    useEffect(() => {
        setStep(1);
    }, []);

    useEffect(() => {
        getOrders(currentPage, searchDate);
    }, [currentPage, searchState, searchType]);

    useEffect(() => {
        if (step === 2) getResumen();
    }, [step]);

    useEffect(() => {
        if (step === 2) getResumen();
    }, [searchDate, searchType, searchState]);

    const handleSearchDateChange = (e) => {
        const value = e.target.value;
        setSearchDate(value);

        const date = new Date(value);
        if (!Number.isNaN(date.getTime()) && date.getFullYear() >= 2025) {
            setCurrentPage(1);
            if (currentPage === 1) getOrders(1, value);
        }
    };

    const handleSearchStateChange = (e) => {
        setSearchState(e.target.value);
        setCurrentPage(1);
    };

    const handleSearchTypeChange = (e) => {
        setSearchType(e.target.value);
        setCurrentPage(1);
    };

    const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));

    const handleOpenOrder = (order) => {
        const dishInfo = safeJsonParse(order?.dish_info) || order?.dish_info || null;

        localStorage.setItem(
            'order',
            JSON.stringify({
                id: order?.id,
                account_id: order?.account_id,
                order_date: order?.order_date,
                type: order?.type,
                status: order?.status,
                dish_info: dishInfo,
                account: order?.account || null,
                version: order?.version || null,
            })
        );

        localStorage.setItem(
            'platillo',
            JSON.stringify({
                ...(dishInfo || {}),
                id: order?.id,
                status: order?.status,
                keylogin: order?.account_id,
                order_date: order?.order_date,
                type: order?.type,
            })
        );

        navigate(`/admin/pedido/ver`);
    };

    const handleActualizarEnviados = (e) => {
        e.preventDefault();
        if (!window.confirm('¿Estás seguro que deseas actualizar todos estos pedidos como enviados?')) return;

        globals.openViewCharge();
        axios
            .post(`${path_api}/update-orders/update_orders.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                search: searchDate,
                searchState,
                searchType,
                status: 'enviado',
            })
            .then((response) => {
                if (response.data?.mensaje === 'success') {
                    getOrders(currentPage, searchDate);
                    if (step === 2) getResumen();
                } else {
                    globals.createAlert({
                        type: 'error',
                        msg_title: 'Error',
                        msg: response.data?.mensaje || 'No se actualizaron los pedidos',
                        effect: 'opacidad 2s, desplazamiento 2s',
                        time_life: 4000,
                    });
                }
            })
            .catch(() => {
                globals.createAlert({
                    type: 'error',
                    msg_title: 'Error',
                    msg: 'Error al actualizar los pedidos',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            })
            .finally(() => {
                globals.closeViewCharge();
            });
    };

    const handleActualizarEntregados = (e) => {
        e.preventDefault();
        if (!window.confirm('¿Estás seguro que deseas actualizar todos estos pedidos como entregados?')) return;

        globals.openViewCharge();
        axios
            .post(`${path_api}/update-orders/update_orders.php`, {
                rute: globals.getRuteBackend(),
                session_id: globals.get_session_id(),
                keylogin: globals.get_keylogin(),
                search: searchDate,
                searchState,
                searchType,
                status: 'entregado',
            })
            .then((response) => {
                if (response.data?.mensaje === 'success') {
                    getOrders(currentPage, searchDate);
                    if (step === 2) getResumen();
                } else {
                    globals.createAlert({
                        type: 'error',
                        msg_title: 'Error',
                        msg: response.data?.mensaje || 'No se actualizaron los pedidos',
                        effect: 'opacidad 2s, desplazamiento 2s',
                        time_life: 4000,
                    });
                }
            })
            .catch(() => {
                globals.createAlert({
                    type: 'error',
                    msg_title: 'Error',
                    msg: 'Error al actualizar los pedidos',
                    effect: 'opacidad 2s, desplazamiento 2s',
                    time_life: 4000,
                });
            })
            .finally(() => {
                globals.closeViewCharge();
            });
    };

    return (
        <div className="page-pedidos container-section flex-column gap-20">
            <h3>Listado de pedidos</h3>

            <div className="container-search">
                <div className="search">
                    <label>Fecha:</label>
                    <input type="date" value={searchDate} onChange={handleSearchDateChange} className="input-primary" />
                </div>

                <div className="container-section flex-row gap-10">
                    <div className="search">
                        <label>Tipo:</label>
                        <select value={searchType} onChange={handleSearchTypeChange} className="input-primary">
                            <option value="">Todos</option>
                            <option value="almuerzo">Almuerzo</option>
                            <option value="cena">Cena</option>
                        </select>
                    </div>

                    <div className="search">
                        <label>Estado:</label>
                        <select value={searchState} onChange={handleSearchStateChange} className="input-primary">
                            <option value="">Todos</option>
                            <option value="programado">Programado</option>
                            <option value="enviado">Enviado</option>
                            <option value="entregado">Entregado</option>
                            <option value="cancelado">Cancelado</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="container-section flex-row gap-20">
                <Link
                    to="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setStep(1);
                    }}
                >
                    Ver pedidos
                </Link>

                <Link
                    to="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setStep(2);
                    }}
                >
                    Ver resumen
                </Link>

                {searchDate !== '' && searchType !== '' && searchState === 'programado' && (
                    <Link to="#" onClick={handleActualizarEnviados}>
                        Actualizar como enviados
                    </Link>
                )}

                {searchDate !== '' && searchType !== '' && searchState === 'enviado' && (
                    <Link to="#" onClick={handleActualizarEntregados}>
                        Actualizar como entregados
                    </Link>
                )}
            </div>

            {step === 1 && (
                <>
                    <div className="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Usuario</th>
                                    <th>Tipo</th>
                                    <th>Platillos seleccionados</th>
                                    <th>Estado</th>
                                    <th>A.</th>
                                </tr>
                            </thead>

                            <tbody>
                                {(orders || []).map((order) => {
                                    const { entry, main, snack } = getOrderDishSnapshot(order);

                                    const entryName = getDishNombre(entry) || '—';
                                    const mainName = getDishNombre(main) || '—';
                                    const snackName = getDishNombre(snack) || '—';

                                    return (
                                        <tr key={order.id}>
                                            <td style={{ width: '120px' }}>{String(order.order_date || '').split(' ')[0]}</td>
                                            <td style={{ width: '140px' }}>{order.account?.nombre || '—'}</td>
                                            <td style={{ width: '110px' }}>{order.type || '—'}</td>

                                            <td>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                                    <span>
                                                        <strong>Entrada:</strong> {entryName}
                                                    </span>
                                                    <span>
                                                        <strong>Fuerte:</strong> {mainName}
                                                    </span>
                                                    <span>
                                                        <strong>Snack:</strong> {snackName}
                                                    </span>
                                                </div>
                                            </td>

                                            <td style={{ width: '130px' }}>{order.status || '—'}</td>

                                            <td className="table-actions" style={{ width: '60px' }}>
                                                <button className="edit-button" onClick={() => handleOpenOrder(order)} title="Ver pedido">
                                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                                        <path d="M3 17.25V21h3.75l11-11-3.75-3.75-11 11zM20.71 7.04a1.003 1.003 0 0 0 0-1.41l-2.34-2.34a1.003 1.003 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                                    </svg>
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}

                                {(!orders || orders.length === 0) && (
                                    <tr>
                                        <td colSpan={6} style={{ padding: 14 }}>
                                            No hay pedidos con los filtros actuales.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="pagination">
                        <button className="button-pagination" onClick={handlePrevPage} disabled={currentPage === 1}>
                            Anterior
                        </button>
                        <p>
                            Página {currentPage} de {totalPages}
                        </p>
                        <button className="button-pagination" onClick={handleNextPage} disabled={currentPage === totalPages}>
                            Siguiente
                        </button>
                    </div>
                </>
            )}

            {step === 2 && (
                <>
                    {searchDate !== '' && searchType !== '' ? (
                        <div className="resumen-pedidos">
                            <div className="platillos-today">
                                <h4>Resumen cocina</h4>
                                <p style={{ marginTop: 6 }}>
                                    <strong>Fecha:</strong> {searchDate} &nbsp;|&nbsp; <strong>Tipo:</strong> {searchType}
                                    {searchState ? (
                                        <>
                                            &nbsp;|&nbsp; <strong>Estado:</strong> {searchState}
                                        </>
                                    ) : null}
                                </p>

                                <p style={{ marginTop: 6 }}>
                                    <strong>Total pedidos:</strong>{' '}
                                    {resumenLoading ? 'Cargando…' : String(resumen?.total ?? 0)}
                                </p>
                            </div>

                            <div className="platillos-today">
                                <h4>Ensaladas</h4>
                                {resumenLoading ? (
                                    <p>Cargando…</p>
                                ) : (resumen?.entradas || []).length > 0 ? (
                                    <ul className="platillos-list">
                                        {resumen.entradas.map((it) => (
                                            <li key={it.nombre}>
                                                <strong>{it.count}</strong> de {it.nombre}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>Sin ensaladas para estos filtros.</p>
                                )}
                            </div>

                            <div className="platillos-today">
                                <h4>Platos fuertes</h4>
                                {resumenLoading ? (
                                    <p>Cargando…</p>
                                ) : (resumen?.fuertes || []).length > 0 ? (
                                    <ul className="platillos-list">
                                        {resumen.fuertes.map((it) => (
                                            <li key={it.nombre}>
                                                <strong>{it.count}</strong> de {it.nombre}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>Sin platos fuertes para estos filtros.</p>
                                )}
                            </div>

                            <div className="platillos-today">
                                <h4>Snacks</h4>
                                {resumenLoading ? (
                                    <p>Cargando…</p>
                                ) : (resumen?.snacks || []).length > 0 ? (
                                    <ul className="platillos-list">
                                        {resumen.snacks.map((it) => (
                                            <li key={it.nombre}>
                                                <strong>{it.count}</strong> de {it.nombre}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>Sin snacks para estos filtros.</p>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="platillos-today">
                            <p>Selecciona una fecha y un tipo para ver el resumen (cocina).</p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default Admin_pedidos;
